import { render } from "./ModalTransition.vue?vue&type=template&id=1826fc48"
const script = {}

import "./ModalTransition.vue?vue&type=style&index=0&id=1826fc48&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__